module.exports = __webpack_public_path__ + "img/c3.75852c78.jpg";